/*eslint-disable no-loop-func*/
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
export const numberMask = createNumberMask({
  allowDecimal: false,
  thousandsSeparatorSymbol: '',
  prefix: ''
})

export function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toTitleCase(string) {
  string = string.replace('%20', ' ').replace('-', ' ')
  return string.replace(/\w\S*/g, function(text){
    return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
  });
}

export function toPathString(string) {
  if (string) {
    string = string.toLowerCase()
    string = string.replace(' & ', '-')
    string = string.replace('%20', '-')
    string = string.replace(' ', '-')
    return string
  }
}

export function isImage(url) {
    return(url.match(/\.(jpeg|jpg|gif|png|JPEG|JPG|GIF|PNG)$/) != null);
}

/* eslint-disable no-useless-escape */
export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function getStrippedNumberFromString(string) {
  let strippedNumber = string.replace(/[\$\,\(\)\-\ ]/g, '');

  return strippedNumber === '' ? 0 : parseFloat(strippedNumber);
}

export function isValidPhoneNumber(phoneNumber) {
  let value = getStrippedNumberFromString(phoneNumber).toString();

  return value.length === 10
}

export function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i=0; i<arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function(v) {
        paramNum = v.slice(1,-1);
        return '';
      });

      // set parameter value (use 'true' if empty)
      var paramValue = typeof(a[1])==='undefined' ? true : a[1];

      // (optional) keep case consistent
      // paramName = paramName.toLowerCase();
      // paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}


export function mathTrunc(value) {
  if (isNaN(value)) {
    return NaN;
  }
  if (value > 0) {
    return Math.floor(value);
  }
  return Math.ceil(value);
};

export function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
export function eraseCookie(name) {
  document.cookie = name+'=; Max-Age=-99999999;';
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js